// ----------------------------------------------------------------------

export type ConfigValue = {
  appName: string;
  appVersion: string;
  serverUrl: string;
  storefrontUrl: string;
  cdnUrl: string;
  sentryEnv: string;
  sentryDsn: string;
  dealerCabinetUrl: string;
  partnerCabinetUrl: string;
  telegramMiniAppUrl: string;
};

// ----------------------------------------------------------------------

export const CONFIG: ConfigValue = {
  appName: 'GAC',
  // Put in by the build (`vite.config.ts`). Not an import of package.json: even a named import of
  // one field leaves the whole manifest in the chunk's public source map (`sourcesContent`).
  appVersion: __APP_VERSION__,
  serverUrl: import.meta.env.VITE_SERVER_URL ?? '',
  // The storefront's own public origin. The variable is called `assets` for what it was first
  // used for; Release derives it from the public domain as `https://{prefix}app.{domain}`
  // (scripts/public-urls.sh). Canonical addresses, link previews and the sitemap are built from it.
  storefrontUrl: import.meta.env.VITE_ASSETS_URL ?? '',
  cdnUrl: import.meta.env.VITE_CDN_URL ?? '',
  sentryEnv: import.meta.env.VITE_SENTRY_ENV ?? '',
  sentryDsn: import.meta.env.VITE_SENTRY_DSN ?? '',
  // Nothing about a chain or a token lives here. Which chains this build carries comes from
  // `VITE_ENABLED_CHAINS` (src/blockchain/chains.ts); the chain of a deal is written on the deal by
  // api, and the token it settles in — address and decimals — is read from api's `/buyer/chains`
  // by the listing's currency (src/utils/dealChain.ts, src/utils/escrowOffer.ts). The build
  // constants that used to name a USDT contract left with one rail M4b (GAC-stacks/infra#106).
  // Where a dealer lands after registering by email: the sales cabinet (a separate app).
  // Release derives it from the public domain (scripts/public-urls.sh); no literal fallback,
  // like its neighbours - a host written here would survive a domain move (infra#52).
  dealerCabinetUrl: import.meta.env.VITE_DEALER_CABINET_URL ?? '',
  // The partner cabinet (a separate app): `Plans` links a logistics, insurance or inspection company to
  // its registration (app#321). Derived like the dealer cabinet's; no literal fallback either.
  partnerCabinetUrl: import.meta.env.VITE_PARTNER_CABINET_URL ?? '',
  // Optional Telegram mini-app deep link for personal users on mobile (t.me/<bot>/<app>).
  // Empty means "not configured" — the register flow then falls back to the web feed.
  telegramMiniAppUrl: import.meta.env.VITE_TELEGRAM_MINI_APP_URL ?? '',
};
